module.exports = __webpack_public_path__ + "static/media/electricity.e6952805.svg";